var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBundled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "-0.8 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "621A6C31-7080-4526-B575-D6209D58D414") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17,0 L17,17 L0,17 L0,0 L17,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "display/small/primary-light/tag",
    stroke: "none",
    fill: "none",
    xlinkHref: "#path-1",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25892,8.24296 L8.75398,2.73802 C8.5306,2.5177 8.2246,2.38 7.888,2.38 L3.604,2.38 C2.92774,2.38 2.38,2.92774 2.38,3.604 L2.38,7.888 C2.38,8.22766 2.5177,8.53366 2.74108,8.75398 L8.24908,14.26198 C8.4694,14.4823 8.7754,14.62 9.112,14.62 C9.4486,14.62 9.75766,14.4823 9.97798,14.26198 L14.26198,9.97798 C14.4823,9.7546 14.62,9.4486 14.62,9.112 C14.62,8.77234 14.4823,8.46634 14.25892,8.24296 Z M4.522,5.44 C4.01404,5.44 3.604,5.02996 3.604,4.522 C3.604,4.01404 4.01404,3.604 4.522,3.604 C5.02996,3.604 5.44,4.01404 5.44,4.522 C5.44,5.02996 5.02996,5.44 4.522,5.44 Z",
    id: "Shape",
    fill: "#7A8E96",
    fillRule: "nonzero"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBundled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-bundled.ef802810075b3a0f0316e87d366d22bc.svg";